import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { resolveIcon } from "@/cms/icons";

const isInternal = (href = "") => href.startsWith("/");

/** Grid of icon cards that each link somewhere — Help Center topics,
 * Careers roles, or any other "pick where to go next" list. */
export default function GenericLinkCards({ fields = {} }) {
  const { eyebrow, headline, items = [] } = fields;

  if (items.length === 0) return null;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {(eyebrow || headline) && (
          <div className="text-center mb-10">
            {eyebrow && (
              <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-3">
                {eyebrow}
              </p>
            )}
            {headline && (
              <h2 className="text-white font-bold text-3xl sm:text-4xl">{headline}</h2>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((item, i) => {
            const Icon = resolveIcon(item.icon);
            const body = (
              <>
                <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/15 flex items-center justify-center shrink-0">
                  <Icon className="h-5 w-5 text-[#D4AF37]" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-white font-semibold mb-1">{item.title}</h3>
                  {item.description && (
                    <p className="text-white/60 text-sm leading-relaxed whitespace-pre-line">
                      {item.description}
                    </p>
                  )}
                  {item.href && item.linkLabel && (
                    <span className="inline-flex items-center gap-1 text-[#D4AF37] text-sm font-semibold mt-3">
                      {item.linkLabel}
                      <ArrowRight className="h-3.5 w-3.5" />
                    </span>
                  )}
                </div>
              </>
            );
            const className =
              "flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-5 hover:border-[#D4AF37]/50 transition-colors";

            if (!item.href) return <div key={i} className={className}>{body}</div>;
            return isInternal(item.href) ? (
              <Link key={i} to={item.href} className={className}>{body}</Link>
            ) : (
              <a key={i} href={item.href} className={className}>{body}</a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
